export default __webpack_public_path__ + "static/media/BackArrow.39e79487.svg";